import _ from 'lodash';
import ui from "storeState/ui";
import auth from "storeState/auth";


export const persistanceKeys = [
  ...ui.localPersistence,
  ...auth.localPersistence
]

const generateActionMap = () => {
    let output = {};
    _.map(persistanceKeys, persistanceItem => {
        _.map(persistanceItem.actions, action => {
            if(!output[action]){
                output[action] = [];
            }
            output[action].push(persistanceItem.path);
        })
    });
    return output;
}

export const actionMap = generateActionMap();



// WEBPACK FOOTER //
// ./src/storeState/persistence/persistanceKeys.js